import React, {Component} from 'react';
import MultiClamp from 'react-multi-clamp';
import {connect} from 'react-redux';

import ProfileAvatar from 'components/ProfileAvatar';
import ProfileLink from 'components/ProfileLink';
import GenderIcon from 'components/GenderIcon';
import MemberType from 'components/MemberType';
import { Link } from 'components/ReactRouterDomLocalized';

import {formatDate} from 'utils/formatDate';
import {t} from 'l10n';

const ORDER_NICK = 'nick';
const ORDER_AGE = 'age';
const ORDER_GENDER = 'gender';
const ORDER_ADDING = 'add_date';
const ORDER_ENDING = 'ending';
const ORDER_REASON = 'reason';

import {unBlackListUser} from 'reducers/member';
import queryString from "query-string";

class BlackListContent extends Component {

    render() {
        let {list, unBlackListUser} = this.props;

        return (
            <table>
                <thead>
                <tr>
                    <th className="avatar"/>
                    <th className="nick"><OrderLink order={ORDER_NICK} props={this.props}>{t('Nick')}</OrderLink></th>
                    <th className="adding_date"><OrderLink order={ORDER_ADDING} props={this.props}>{t('Adding date')}</OrderLink></th>
                    <th className="expiration_date">{t('Expiration date')}</th>
                    <th className="reason">{t('Reason')}</th>
                    <th className="unblock"/>
                </tr>
                </thead>
                <tbody>
                {list.map((user) =>
                    <tr key={user.target_user.id}>
                        <td className="avatar">
                            <ProfileAvatar user={user.target_user}/>
                            <ProfileAvatar user={user.target_user} big/>
                        </td>
                        <td className="nick" title={user.target_user.nick}>
                            <GenderIcon user={user.target_user}/>
                            <ProfileLink user={user.target_user}/>
                            <MemberType memberType={user.target_user.member_type}/>
                        </td>
                        <td className="adding_date">
                            <div className="name">{t('Adding date')}</div>
                            {formatDate(user.add_date)}
                        </td>
                        <td className="expiration_date">
                            <div className="name">{t('Expiration date')}</div>
                            {user.expiration_date === null ? t('Never') : formatDate(user.expiration_date)}
                        </td>
                        <td className="reason">
                            <div className="name">{t('Reason')}</div>
                            {user.reason}
                        </td>
                        <td className="unblock">
                            <div onClick={() => unBlackListUser(user.target_user.id)}>
                                <span className="unblock_text">{t('unblock')}</span>
                                <span className="unblock_icon" />
                            </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        )
    }
}

function OrderLink({children, order, props, className}) {
    const newState = {};

    let classNames = ['order', className];

    if (order === props.order) {
        classNames.push('selected');
        if (props.desc) classNames.push('desc');

        newState.desc = props.desc == 0 ? 1 : 0;

    } else {
        newState.desc = 0;
    }

    return <Link to={{
            pathname: props.pathname,
            search: queryString.stringify({page: props.page, order: order, desc: newState.desc ? 1:0})
        }} className={classNames.join(' ')}  >{children}</Link>
}

export default connect(
    null,
    {
        unBlackListUser: unBlackListUser
    }
)(BlackListContent);


// WEBPACK FOOTER //
// ./src/containers/member/blackList/BlackListContent.js